type PowderFlowChatRuntimeConfig = {
  supabaseUrl?: string;
  supabasePublishableKey?: string;
  powderflowAppUrl?: string;
};

declare global {
  interface Window {
    __POWDERFLOW_CHAT_CONFIG__?: PowderFlowChatRuntimeConfig;
  }
}

const runtime = typeof window !== 'undefined' ? window.__POWDERFLOW_CHAT_CONFIG__ ?? {} : {};

export const chatRuntimeConfig = {
  supabaseUrl: runtime.supabaseUrl || import.meta.env.VITE_SUPABASE_URL || '',
  supabasePublishableKey:
    runtime.supabasePublishableKey || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '',
  powderflowAppUrl:
    runtime.powderflowAppUrl || import.meta.env.VITE_POWDERFLOW_APP_URL || '',
};

if (!chatRuntimeConfig.supabaseUrl || !chatRuntimeConfig.supabasePublishableKey) {
  throw new Error(
    'PowderFlow Chat is missing SUPABASE_URL/SUPABASE_PUBLISHABLE_KEY runtime configuration.',
  );
}
